export class NewRequest {
    internalReference: string;
    portalId: number;
    requestedBy: string;
}
